<template>
  <article class="classes">
    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Nueva clase</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'classes_classes'})"
                  class="breadcums__option"
                >
                  Listado de clases
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Nueva clase
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-0">
              <button
                class="faccess_button px-5"
                @click="createOffer()"
              >
                Crear
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <v-layout row wrap>
          <v-flex xs6>
            <!-- Fotos de la oferta -->
            <span class="table_card__info--label">Imagen</span>
            <div class="trainers__form--photo_container">
              <label
                for="trainerPhoto"
                class="faccess_button buttom_shadow px-5">Examinar</label>
              <input
                id="trainerPhoto"
                type="file"
                @change="onFileChange"
                name="logo"
                multiple>
              <p v-if="!url_change">{{ photo_name }}</p>
            </div>
            <v-flex
              xs12
              v-if="url_change"
              class="classes__image_container">
              <div
                v-for="(image, index) in urls"
                class="classes__image_container--image"
                :style="{backgroundImage: 'url('+ image +')'}">
                <div
                  class="data_card__info--remove"
                  @click="removeImage(index)">
                  <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
                </div>
              </div>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Título</span>
              <input
                class="faccess_input"
                type="text"
                name="Title"
                placeholder="Título de la clase"
                v-model="offer.attributes.title">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Descripción</span>
              <textarea 
                class="faccess_textarea"
                placeholder="Descripción"
                v-model="offer.attributes.description"
              ></textarea>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Términos y condiciones</span>
              <textarea 
                class="faccess_textarea"
                placeholder="Términos y condiciones generales de la clase"
                v-model="offer.attributes.tc"
              ></textarea>
            </v-flex>
            <!-- <v-flex xs12>
              <span class="data_card__info--label">Fecha de vencimiento</span>
              <app-single-date-picker @filterQuery="changeDate($event)"></app-single-date-picker>
            </v-flex> -->
            <v-flex xs12>
              <span class="table_card__info--label">Entrenadores</span>
              <div
                class="faccess_select"
                style="width: 100%; margin-bottom: 20px;"
                @click="show_trainers_modal = true">
                <p>{{trainers_text}}</p>
                <img src="@/assets/img/arrow-down-solid.svg">
              </div>
            </v-flex>
            <v-flex xs12>
              <div class="data_card__counter data_card__counter--center_align">
                <p>Canjes por usuario: </p>
                <input
                  class="data_card__counter--number_input"
                  type="number"
                  name="limit_per_user"
                  placeholder=""
                  v-model="offer.attributes.redeem_limit_per_user"
                  min="0">
                <div
                  class="data_card__counter--button"
                  @click="removeFromRedemption()"></div>
                <div
                  class="data_card__counter--button"
                  @click="addToRedemption()"></div>
              </div>
            </v-flex>
            <v-flex xs12>
              <div class="data_card__counter data_card__counter--center_align">
                <p>Limite de dias para canjear las clases: </p>
                <input
                  class="data_card__counter--number_input"
                  type="number"
                  name="limit_days"
                  v-model="offer.attributes.limit_days"
                  min="0">
                <div
                  class="data_card__counter--button"
                  @click="removeFromLimitDays()"></div>
                <div
                  class="data_card__counter--button"
                  @click="addToLimitDays()"></div>
              </div>
            </v-flex>
          </v-flex>
          <v-flex xs6 >
            <v-flex xs11 offset-xs1>
              <section class="data_card data_card__instance">
                <div
                  class="data_card__image"
                  :class = "{'without_url' : !url_change}"
                  :style="{backgroundImage: 'url('+ urls[0] +')'}"></div>
                <div class="data_card__info">
                  <div class="data_card__info--container">
                    <p class="data_card__info--title">
                      {{offer.attributes.title}}
                    </p>
                  </div>
                  <!-- <div class="data_card__info--container">
                    <p class="data_card__info--text expiration">
                      {{ offer.attributes.expiration != '' ? `Hasta ${offer.attributes.expiration}` : ''}}
                    </p>
                  </div> -->
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Descripción</span>
                    <p class="data_card__info--text full_text">
                      {{offer.attributes.description}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Términos y condiciones</span>
                    <p class="data_card__info--text full_text">
                      {{offer.attributes.tc}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Numero de clases</span>
                    <p class="data_card__info--text classes_quantity">
                      {{Number(offer.attributes.redeem_limit_per_user) > 0 ? offer.attributes.redeem_limit_per_user : ''}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Entrenadores</span>
                    <section class="data_card__info--trainers_container">
                      <div
                        class="data_card__info--trainer default_trainer"
                        v-if="selected_trainers.length <= 0">
                      </div>
                      <div
                        class="data_card__info--trainer"
                        v-else
                        v-for="(trainer, index) in selected_trainers"
                        :style="{backgroundImage: `url('${getImageServer() + trainer.attributes.image.thumb.url}')`}">
                        <div
                          class="data_card__info--remove"
                          @click="removeTrainer(index)">
                          <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </section>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button px-5"
          @click="createOffer()"
        >
          Crear
        </button>
      </div>
    </div>
    
    <trainers-modal
      v-if="show_trainers_modal"
      :trainers="locations"
      :selected="selected_trainers"
      :title = "'Selecciona Entrenadores'"
      @closeTrainersModal="closeTrainersModal($event)"
      @saveTrainers="filterSelectedTrainers($event)"></trainers-modal>
  </article>
</template>

<script>
export default {
  data(){
    return{
      urls: ['https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg'],
      images: [],
      locations:[],
      tags_selected: [],
      parent_category:null,
      conditions: [],
      condition_selected: '',
      is_valid: false,
      locations_selected: [],
      url_change: false,
      photo_name: "No se han seleccionado archivos",
      trainers_text: 'Selecciona los entrenadores',
      show_trainers_modal: false,
      selected_trainers: [],
      offer:{
        attributes:{
          title: '',
          description: '',
          is_class:true,
          offer_photos_attributes: [],
          tc: '',
          expiration: '',
          is_rewardable: false,
          is_multi_redeemable_per_user: true,
          redeem_limit_per_user: 0,
          redeem_limit: -1,
          redeem_count: 0,
          published: true,
          limit_days: null
        },
        offer_photos_attributes: [],
        location_offers_attributes: [] // offer_id: ''
      }
    }
  },
  mounted(){
    try {
      this.$http.get('classes/index_trainers',
      {headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}})
      .then(function(response){
        this.locations = response.body.data;
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      }, function(response){
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
      })
    } catch (e) {
      alert(e.message)
    }
  },
  watch:{
    urls(){
      this.url_change = true;
    }
  },
  methods:{
    deleteImage(index){
      // if(this.offer_photos[index].id != undefined && this.offer_photos[index].id != null){
      //   this.offer_photos[index]._destroy = this.offer_photos[index].id
      //   this.offer.offer_photos_attributes.push({id: this.offer_photos[index].id, _destroy: this.offer_photos[index]._destroy})
      // }
      // this.offer_photos.splice(index, 1)
      this.urls.splice(index, 1)
      this.offer.offer_photos_attributes.splice(index,1)
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.urls = []
      for (var i = 0; i < files.length; i++) {
        this.urls.push(URL.createObjectURL(files[i]));
        // this.images.push(files[i])
        this.createImage(files[i])
      }
      this.photo_name = files[0].name
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.offer.offer_photos_attributes.push({image: reader.result})
      }
    },
    createOffer(){
      this.is_valid = true
      for (var i = 0; i < this.selected_trainers.length; i++) {
        this.offer.location_offers_attributes.push({location_id: this.selected_trainers[i].id})
      }
      try {
        this.$http.post('offers',{
          data: this.encrypt(this.offer).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
          this.$router.push({name: 'classes_classes'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    changeDate(val){
      this.offer.attributes.expiration = val
    },
    closeTrainersModal(val){
      this.show_trainers_modal = val
    },
    filterSelectedTrainers(val){
      // cl val
      this.selected_trainers = val
      this.trainers_text = val.length > 1 ? `${val.length} seleccionados` : `${val.length} seleccionado`
      this.show_trainers_modal = false;
    },
    addToRedemption(){
      this.offer.attributes.redeem_limit_per_user = Number(this.offer.attributes.redeem_limit_per_user) + 1
    },
    removeFromRedemption(){
      if(Number(this.offer.attributes.redeem_limit_per_user) > 0){
        this.offer.attributes.redeem_limit_per_user = Number(this.offer.attributes.redeem_limit_per_user) - 1
      }
    },
    addToLimitDays(){
      this.offer.attributes.limit_days = Number(this.offer.attributes.limit_days) + 1
    },
    removeFromLimitDays(){
      if(Number(this.offer.attributes.limit_days) > 0){
        this.offer.attributes.limit_days = Number(this.offer.attributes.limit_days) - 1
      }
    },
    removeImage(index){
      this.$delete(this.urls, index)
    },
    removeTrainer(index){
      this.$delete(this.selected_trainers, index)
    }
  }
}
</script>

<style lang="css">


.text_title{
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/classes/New_class.vue